import { Component } from '@angular/core';
import { Platform } from 'ionic-angular';

// let config = {
//     apiKey: "AIzaSyC8SrqoYY0MmNfx8uorG_U29x9j-Bne-dA",
//     authDomain: "dropcard-test.firebaseapp.com",
//     databaseURL: "https://dropcard-test.firebaseio.com",
//     projectId: "dropcard-test",
//     storageBucket: "dropcard-test.appspot.com",
//     messagingSenderId: "91242506625"
//   };
// firebase.initializeApp(config);

import { HomePage } from '../pages/home/home';
@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  rootPage:any = HomePage;

  constructor(platform: Platform) {
    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
    });
  }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts